import "@/App.css";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Journey } from "@/components/Journey";
import { Therapies } from "@/components/Therapies";
import { Work } from "@/components/Work";
import { Prices } from "@/components/Prices";
import { Approach } from "@/components/Approach";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <About />
        <Journey />
        <Therapies />
        <Work />
        <Prices />
        <Approach />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
